import { Pokemon, Move, Type } from '@/types';

export interface Resource {
  pokemons: Pokemon[];
  moves: Move[];
  types: Type[];
}

async function fetch<T>(path: string): Promise<T> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', path);
    xhr.onload = (): void => {
      if (xhr.status !== 200) {
        reject();
        return;
      }

      const data = JSON.parse(xhr.responseText);
      resolve(data as T);
    };
    xhr.onerror = (e): void => {
      reject(e);
    };
    xhr.send();
  });
}

export async function fetchResource(): Promise<Resource | undefined> {
  const path = process.env.VUE_APP_JSON_PATH;
  return await fetch<Resource>(path);
}
